// Models
import {
  ProductsV2,
  ProductV2,
  ProductV2Brand,
  ProductV2Posa,
  ProductV2Type,
  TypePosaBrandProductV2,
  TypePosaProductsV2,
  TypeProductsV2,
} from 'models';

class ProductV2Source {
  private readonly products: ProductsV2;

  public constructor(products?: ProductsV2) {
    this.products = products;
  }

  public getProducts(): ProductsV2 {
    return this.products;
  }

  public getProductsByType(productType: ProductV2Type): TypeProductsV2 {
    return this.getProducts()?.types[productType];
  }

  public getProductsByTypePosa(productType: ProductV2Type, productPosa: ProductV2Posa): TypePosaProductsV2 {
    return this.getProductsByType(productType)?.posas[productPosa];
  }

  public getProductByTypePosaBrand(
    productType: ProductV2Type,
    productPosa: ProductV2Posa,
    productBrand: ProductV2Brand,
  ): TypePosaBrandProductV2 {
    return this.getProductsByTypePosa(productType, productPosa)?.brands[productBrand];
  }

  public getProduct(productType: ProductV2Type, productPosa: ProductV2Posa, productBrand: ProductV2Brand): ProductV2 {
    return this.getProductByTypePosaBrand(productType, productPosa, productBrand)?.product;
  }
}

export { ProductV2Source };
